import React from 'react'
import PropTypes from 'prop-types'
import { Menu, Dropdown, Layout, Avatar, Badge } from 'antd'
import {
    EditOutlined,
    SettingFilled,
    LogoutOutlined,
    GithubOutlined,
    BellOutlined,
    UserOutlined,
    MenuUnfoldOutlined,
    MenuFoldOutlined,
} from '@ant-design/icons'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { 
  setAdminDataAction, 
  setAdminPageFlagAction
} from '@/store/slices/adminSlice'

const { Header } = Layout

const AppHeader = props => {
    let { menuClick, avatar, menuToggle, loginOut } = props;
    const navigate = useNavigate()
    const dispatch = useDispatch();

    const loginInfo = JSON.parse(localStorage.getItem('userInfo'))
    
    // 添加管理员
    const goCreateAdmin = ()=>{
        dispatch(setAdminDataAction({}))
        dispatch(setAdminPageFlagAction('create'))
        navigate('/admin/adminCreate');
    }

    // 编辑管理员
    const goEditAdmin = ()=>{
        dispatch(setAdminDataAction(loginInfo))
        dispatch(setAdminPageFlagAction('edit'))
        navigate('/admin/adminEdit');
    }

    // 修改密码
    const goAuth = ()=>{
        dispatch(setAdminDataAction(loginInfo))
        dispatch(setAdminPageFlagAction('changePassword'))
        navigate('/admin/changePassword');
    }
    
    const superMenuItems = [
        {
            key: 'group1',
            type: 'group',
            label: '用户设置',
            children: [
                {
                    key: 'divider1',
                    type: 'divider',
                },
                {
                    key: 'personal',
                    icon: <UserOutlined />,
                    label: (
                        <span onClick={goEditAdmin}>
                            个人信息
                        </span>
                    )
                },
                {
                    key: 'password',
                    icon: <EditOutlined />,
                    label: (
                        <span onClick={goAuth}>
                            修改密码
                        </span>
                    )
                },
                {
                    key: 'system',
                    icon: <SettingFilled />,
                    label: (
                        <span onClick={goCreateAdmin}>
                            添加管理员
                        </span>
                    )
                },
            ],
        },
        {
            key: 'divider2',
            type: 'divider',
        },
        {
            key: 'logout',
            icon: <LogoutOutlined />,
            label: (
                <span onClick={loginOut}>
                    退出登录
                </span>
            ),
        },
    ]
    const menuItems = [
        {
            key: 'group1',
            type: 'group',
            label: '用户设置',
            children: [
                {
                    key: 'divider1',
                    type: 'divider',
                },
                {
                    key: 'personal',
                    icon: <UserOutlined />,
                    label: (
                        <span onClick={goEditAdmin}>
                            个人信息
                        </span>
                    )
                },
                {
                    key: 'password',
                    icon: <EditOutlined />,
                    label: (
                        <span onClick={goAuth}>
                            修改密码
                        </span>
                    )
                },
            ],
        },
        {
            key: 'divider2',
            type: 'divider',
        },
        {
            key: 'logout',
            icon: <LogoutOutlined />,
            label: (
                <span onClick={loginOut}>
                    退出登录
                </span>
            ),
        },
    ]

    // const menu = <Menu items={menuItems} />

    return (
        <Header className='header'>
            <div className='left'>
                {menuToggle ? (
                    <MenuUnfoldOutlined 
                        style={{ fontSize: '2rem', cursor: 'pointer' }}
                        onClick={menuClick}
                    />
                ) : (
                    <MenuFoldOutlined 
                        style={{ fontSize: '2rem', cursor: 'pointer' }}
                        onClick={menuClick}
                    />
                )}
            </div>
            <div className='right'>

                <div className='mr15'>
                    {loginInfo?.name}
                </div>
                <div>
                    <Dropdown 
                        menu={{ items: loginInfo?.username == 'admin' ? superMenuItems : menuItems }} 
                        overlayStyle={{ width: '20rem' }}
                        placement="bottomRight"
                    >
                        <div className='ant-dropdown-link' style={{ cursor: 'pointer' }}>
                            <Avatar 
                                icon={<UserOutlined />} 
                                src={avatar} 
                                alt='avatar' 
                            />
                        </div>
                    </Dropdown>
                </div>
            </div>
        </Header>
    )
}

AppHeader.propTypes = {
    menuClick: PropTypes.func,
    avatar: PropTypes.string,
    menuToggle: PropTypes.bool,
    loginOut: PropTypes.func
}

export default React.memo(AppHeader)